import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'App',
  components: {},
  setup() {
    const contentHtml = ref('Hello world!');
    const token = ref('');
    const params = ref('');
    const getContent = (content, id) => {
      console.log('id=', id);
      contentHtml.value = content;
    };
    const save = () => {
      alert(contentHtml.value);
    };
    token.value = 'b9fa3e1f2fd0bcfc75aa7a5efd9d9d2b';
    params.value = '{"field_name":"pic"}';
    const dialogVisible = ref(false); //上传弹窗
    const fileObj = ref();
    const uploadAction = (fileInfo, from) => {
      fileObj.value = fileInfo;
      dialogVisible.value = true;
      console.log(fileInfo, from);
    };
    //保存文件信息，如可将文件管理器中选择的文件信息保存
    const saveFile = () => {
      fileObj.value.url = 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/300';
      dialogVisible.value = false;
    };
    return {
      getContent,
      contentHtml,
      save,
      token,
      params,
      dialogVisible,
      uploadAction,
      saveFile
    };
  }
});